import React from "react";
import "./about.css";
import { Fade } from "react-reveal";
import Header from "../../components/header/Header.js";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton.js";
import { useState } from "react";
import AboutImage from "./aboutImg";
import { aboutsListe } from "portfolio";


const About = (props) => {
    const [showMore, setShowMore] = useState(false);
    const theme = props.theme;  // Utiliser les props

    return (
        <div className="experience-main">
            <Header theme={theme} />
            <div className="basic-experience">
                <Fade bottom duration={2000} distance="40px">
                    <div className="experience-heading-div">
                        <div className="experience-heading-img-div">
                            <AboutImage theme={theme} />
                        </div>
                        <div className="experience-heading-text-div">
                            <h1
                                className="experience-heading-text"
                                style={{ color: theme.text }}
                            >
                                {aboutsListe.title}
                            </h1>
                            <h3
                                className="experience-heading-sub-text"
                                style={{ color: theme.text }}
                            >
                                {aboutsListe["subtitle"]}
                            </h3>
                            <p
                                className="experience-header-detail-text subTitle"
                                style={{ color: theme.secondaryText }}
                            >
                                {aboutsListe["description"]}
                                {showMore && (
                                    <div>
                                        {aboutsListe["description2"]}
                                        <br />
                                        {aboutsListe["description3"]}
                                        <br />
                                        {aboutsListe["description4"]}
                                    </div>
                                )}{" "}
                                <a href="#/" onClick={() => setShowMore(!showMore)} className="text-blue-500 hover:underline">
                                    {showMore ? 'Voir moins' : 'Voir plus'}
                                </a>
                            </p>
                        </div>
                    </div>
                </Fade>
            </div>
            <Footer theme={props.theme} onToggle={props.onToggle} />
            <TopButton theme={props.theme} />
        </div>
    );
};

export default About;
